import { useRoutes } from "react-router-dom";
import HomePage from "./containers/HomePage";
import BlogContent from "./containers/BlogContent";
import UserLogin from "./containers/user/login";
import UserRegister from "./containers/user/register";
import ChatGPT from "./containers/user/gpt";
import BlogCreate from "./containers/BlogEidter/BlogCreate";
import BlogEdit from "./containers/BlogEidter/BlogEidt";
import AboutUser from "./containers/user/about";

const MainRoutes = {
  path: "/",
  element: <HomePage />,
  // children: [
  //   {
  //     path: "/homepage",
  //     element: <HomePage />,
  //   },
  // ],
};

const BlogPageRoutes = {
  path: "/",
  // element: <HomePage />,
  children: [
    {
      path: "/blogs",
      element: <BlogContent />,
    },
    {
      path: "/blog",
      children: [
        {
          path: "create",
          element: <BlogCreate />,
        },
        {
          path: "edit",
          element: <BlogEdit />,
        },
      ],
    },
    {
      path: "/user",
      children: [
        {
          path: "login",
          element: <UserLogin />,
        },
        {
          path: "register",
          element: <UserRegister />,
        },
        {
          path: "about",
          element: <AboutUser />,
        },
        {
          path: "chatGPT",
          element: <ChatGPT />,
        },
      ],
    },
  ],
};

export default function Routes() {
  return useRoutes([MainRoutes, BlogPageRoutes]);
}
